// @flow
import type {
  Recommendation,
} from 'hfty-model-recommendations/types'


// Libs
import React, { Component } from 'react'
import { Redirect } from 'react-router'
import _find from 'lodash/find'
import _findIndex from 'lodash/findIndex'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

// messages
import {
  messages as recommendation_messages,
} from 'hfty-recommendations'

// container
import RecommendationStatusBarContainer from '../containers/RecommendationStatusBar'

// Components
import Button from '@react-mdc/button'

// Constants
import {
  PROP_ID,
  PROP_STATUS,
  FARM_COMMAND,
  FERT_CALC,
  PATRICIA,
  AG_INTEGRATED,
  COMPLETE,
} from 'hfty-model-recommendations'

// Styles
import '../styles/styles.css'
import { lightGrey, grey, primary } from 'hfty-styles/src/colors'

const styles = {
  container: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    padding: 10,
    backgroundColor: lightGrey(0.8),
    display: 'flex',
    alignItems: 'center',
  },
  body: {
    margin: '10px auto',
    padding: 10,
    color: grey(0.9),
  },
  title: {
    fontSize: '1.4em',
    fontWeight: 500,
    textAlign: 'center',
    margin: '20px 0',
  },
  progressMessage: {
    fontWeight: 500,
    textAlign: 'center',
    margin: '20px 0',
    marginBottom: 40,
  },
  progressGeneralInfo: {
    margin: '10px 0',
  },
  progressBar: {
    display: 'flex',
    justifyContent: 'center',
  },
  barElement: (done: boolean): Object => ({
    width: 40,
    height: 40,
    margin: 5,
    backgroundColor: done ? primary(0.8) : grey(0.2),
  }),
}

type Props = {
  match: Object,
  recommendations: Array<Recommendation>,
  actions: {
    fetchRecommendationById: Function,
  }
}
const STATUS_BY_ORDER = [
  FARM_COMMAND,
  FERT_CALC,
  PATRICIA,
  AG_INTEGRATED,
  COMPLETE,
]

const DELAY = 30000

class RecommendationStatusBar extends Component {
  props: Props

  componentDidMount () {
    this.fetchRecommendationOnInterval()
  }

  componentWillUnmount () {
    clearInterval(this.intervalID)
  }

  fetchRecommendationOnInterval () {
    const { match } = this.props
    this.intervalID = setInterval(() => {
      this.props.actions.fetchRecommendationById({
        recommendationId: match.params.recommendationId,
      })
    }, DELAY)
  }

  getRecommendationInfo (): Object {
    const { match, recommendations } = this.props

    const recommendation = _find(recommendations,
      (recommendation: Recommendation): boolean =>
        recommendation[PROP_ID] === Number(match.params.recommendationId)) || {}

    const status_index = _findIndex(STATUS_BY_ORDER,
      (status: string): boolean => status === recommendation[PROP_STATUS])

    return {
      recommendation,
      status_index,
    }
  }

  render (): React.Element<any> {
    const { match } = this.props
    const { status_index } = this.getRecommendationInfo()

    if (status_index === 4) {
      // Rec generation complete
      return (<Redirect to={`/recommendations/${match.params.jobId}/?paginate=last`} />)
    }

    return (
      <div
        data-test='hfty-recommendations-dom/RecommendationStatusBar'
        style={styles.container}>
        <div style={styles.header}>
          <Link to={`/recommendations/${match.params.jobId}`}>
            <Button
              raised
              dense
              primary
            >
              Back
            </Button>
          </Link>
        </div>
        <div style={styles.body}>
          <div style={styles.title}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.generatingRecommendation']} />
          </div>
          <div style={styles.progressBar}>
            <div className={status_index + 1 === 0 && 'blinking'} style={styles.barElement(status_index + 1 >= 0)} />
            <div className={status_index + 1 === 1 && 'blinking'} style={styles.barElement(status_index + 1 >= 1)} />
            <div className={status_index + 1 === 2 && 'blinking'} style={styles.barElement(status_index + 1 >= 2)} />
            <div className={status_index + 1 === 3 && 'blinking'} style={styles.barElement(status_index + 1 >= 3)} />
            <div className={status_index + 1 === 4 && 'blinking'} style={styles.barElement(status_index + 1 >= 4)} />
          </div>
          <div style={styles.progressMessage}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.progressMessage']} />
          </div>
          <div style={styles.progressGeneralInfo}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.progressGeneralInfo1']} />
          </div>
          <div style={styles.progressGeneralInfo}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.progressGeneralInfo2']} />
          </div>
        </div>
      </div>
    )
  }
}

export default RecommendationStatusBarContainer(RecommendationStatusBar)
